export const ASSIGNMENT_UPDATED_EVENT = 'assignment_updated';

export const ACTIVITY_ASSIGNED_EVENT = 'activity_assigned';
